"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.every.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.string.includes.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _menu = _interopRequireDefault(require("../menu"));

var _MinusOutlined = _interopRequireDefault(require("@ant-design/icons/MinusOutlined"));

var _PlusOutlined = _interopRequireDefault(require("@ant-design/icons/PlusOutlined"));

var _UpOutlined = _interopRequireDefault(require("@ant-design/icons/UpOutlined"));

var _DownOutlined = _interopRequireDefault(require("@ant-design/icons/DownOutlined"));

var _isHexColor = _interopRequireDefault(require("validator/lib/isHexColor"));

var _Sensor = require("@meepshop/context/lib/Sensor");

var _constant = require("../mobileLayout/constant");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

require("./styles/index.less");

var styles = {
  "root": "meepshop-meep-ui__bottom-index__root",
  "menu": "meepshop-meep-ui__bottom-index__menu",
  "wrapper": "meepshop-meep-ui__bottom-index__wrapper",
  "logoWrapper": "meepshop-meep-ui__bottom-index__logoWrapper",
  "menuWrapper": "meepshop-meep-ui__bottom-index__menuWrapper",
  "socialMediaWrapper": "meepshop-meep-ui__bottom-index__socialMediaWrapper",
  "socialMediaIcon": "meepshop-meep-ui__bottom-index__socialMediaIcon",
  "link": "meepshop-meep-ui__bottom-index__link",
  "menuTitle": "meepshop-meep-ui__bottom-index__menuTitle",
  "submenuTitle": "meepshop-meep-ui__bottom-index__submenuTitle",
  "top4": "meepshop-meep-ui__bottom-index__top4",
  "mask": "meepshop-meep-ui__bottom-index__mask",
  "line": "meepshop-meep-ui__bottom-index__line",
  "slogan": "meepshop-meep-ui__bottom-index__slogan",
  "left": "meepshop-meep-ui__bottom-index__left",
  "right": "meepshop-meep-ui__bottom-index__right",
  "center": "meepshop-meep-ui__bottom-index__center"
};

var getIcon = function getIcon(mobileExpandType, isOpen) {
  if (mobileExpandType === _constant.EXPAND_TYPE.FULL) {
    return isOpen ? _MinusOutlined["default"] : _PlusOutlined["default"];
  }

  return isOpen ? _UpOutlined["default"] : _DownOutlined["default"];
};

var MenuList = function MenuList(_ref) {
  var pages = _ref.pages,
      design = _ref.design,
      normal = _ref.normal,
      background = _ref.background,
      fontSize = _ref.fontSize,
      openKeys = _ref.openKeys,
      setOpenKeys = _ref.setOpenKeys,
      hoverColor = _ref.hoverColor,
      alignment = _ref.alignment,
      _ref$mobileExpandType = _ref.mobileExpandType,
      mobileExpandType = _ref$mobileExpandType === void 0 ? _constant.EXPAND_TYPE.FULL : _ref$mobileExpandType;

  var _useSensorContext = (0, _Sensor.useSensorContext)(),
      isMobile = _useSensorContext.isMobile;

  var removeIcon = function removeIcon(currentPages) {
    return (currentPages || []).map(function (page) {
      return _objectSpread(_objectSpread({}, page), {}, {
        image: null,
        pages: removeIcon(page.pages)
      });
    });
  };

  var mobileExpandIcon = function mobileExpandIcon(_ref2) {
    var isOpen = _ref2.isOpen;
    var Icon = getIcon(mobileExpandType, isOpen);
    return /*#__PURE__*/_react["default"].createElement(Icon, {
      className: "arrow-icon"
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_menu["default"], {
    id: "bottom",
    className: styles.menu,
    pages: removeIcon(pages),
    expandIcon: isMobile ? mobileExpandIcon : undefined,
    design: _objectSpread(_objectSpread({}, design), {}, {
      showLogo: false,
      showSearchbar: false,
      expandSubItem: true,
      alignment: alignment || 'center',
      pattern: 0,
      normal: normal,
      opacity: !background || !(0, _isHexColor["default"])(background || '') ? 0 : 1,
      active: {},
      hover: {
        color: hoverColor
      },
      fontSize: fontSize || 13,
      font: '黑體',
      width: 0,
      height: 0
    }),
    onOpenChange: function onOpenChange(newOpenKeys) {
      if (!isMobile) return;
      var latestOpenKey = newOpenKeys.find(function (key) {
        return !openKeys.includes(key);
      });
      if (pages.every(function (_ref3) {
        var pageId = _ref3.id;
        return pageId !== latestOpenKey;
      })) setOpenKeys(newOpenKeys);else setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    },
    openKeys: openKeys
  });
};

var _default = MenuList;
exports["default"] = _default;